/**
 * 大会結果画面のUI定数
 */

export const TOURNAMENT_RESULT_LAYOUT = {
  titleY: 50,
  subtitleY: 90,
  tableStartY: 130,
  tableRowHeight: 35,
  buttonStartY: 460,
  buttonSpacing: 50,
} as const;

export const TOURNAMENT_RESULT_LABELS = {
  roundRobinTitle: '総当たり戦 結果',
  eliminationTitle: 'トーナメント戦 結果',
  playerRankPrefix: 'あなたの順位: ',
  rank: '順位',
  name: '名前',
  species: '種族',
  win: '勝',
  lose: '負',
  draw: '分',
  pts: '勝点',
  champion: '優勝！',
  retry: 'もう一度',
  toTitle: 'タイトルへ',
} as const;
